(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/gaming-info/gaming-history.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/gaming-info/gaming-history.js');

'use strict';

svs.player_login.views.GamingHistory = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.gaming_history(data);
  },
  modelEvents: {
    sync: 'setSync',
    error: 'setError',
    'change:hasSync': 'render',
    'change:hasError': 'render'
  },
  model: new svs.player_login.models.GamingHistory(),
  templateContext() {
    return {
      returnUrl: this.options.returnUrl,
      isPnp: this.options.isPnp,
      pnpContinueUrl: this.options.pnpContinueUrl
    };
  },
  behaviors: [svs.player_login.behaviors.Navigation],
  initialize() {
    this.model.fetch();
  },
  setSync() {
    this.model.set('hasSync', true);
  },
  setError(model, resp) {
    if (resp.status === 404) {
      this.setSync();
    } else {
      this.model.set('hasError', true);
    }
  }
});

 })(window);